/**
 * 不确定页面级默认滚动条挂在哪时使用
 * @return document | body.没页面级滚动条返回document.
 */
let documentScroll: HTMLElement | Document | undefined = undefined;
export default function getDocumentScroll(): HTMLElement | Document {
    if (documentScroll !== undefined) return documentScroll;
    let t: HTMLElement | Document;
    documentScroll = (((t = document.documentElement) || (t = document.body.parentNode as HTMLElement))
        && typeof t.scrollTop == 'number' ? t : document.body);
    
    return documentScroll;
}